var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.anchorLinkClasses},[_c('a',{class:_vm.linkTitleClasses,attrs:{"href":_vm.href,"data-scroll-offset":_vm.scrollOffset,"data-href":_vm.href,"title":_vm.title},on:{"click":function($event){$event.preventDefault();return _vm.goAnchor($event)}}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48e3a74d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/anchor/anchor-link.vue
// module id = 548
// module chunks = 0 1 28